import { createConfirmation } from "react-confirm";
import AddNewGlobalUnitConvertDialog from "./AddNewGlobalUnitConvertDialog";

export const showAddNewGlobalUnitConvertDialog = createConfirmation(AddNewGlobalUnitConvertDialog);
